var render = function render(){
  var _vm$selectedItem, _vm$selectedItem$othe, _vm$selectedItem2, _vm$selectedItem$stat;
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('b-row', {
    staticStyle: {
      "position": "relative"
    }
  }, [_vm.isApprove ? _c('div', {
    staticClass: "position-absolute",
    staticStyle: {
      "top": "-10px",
      "right": "20px",
      "z-index": "1"
    }
  }, [!((_vm$selectedItem = _vm.selectedItem) !== null && _vm$selectedItem !== void 0 && _vm$selectedItem.isApprove) ? _c('i', {
    staticClass: "fa fa-close text-danger",
    staticStyle: {
      "font-size": "40px"
    }
  }) : _c('i', {
    staticClass: "fa fa-check text-success",
    staticStyle: {
      "font-size": "40px"
    }
  })]) : _vm._e(), _c('b-col', {
    staticClass: "mb-3 text-gray",
    attrs: {
      "md": "2"
    }
  }, [_vm._v(" Equipment Name ")]), _c('b-col', {
    attrs: {
      "md": "4"
    }
  }, [_vm._v(_vm._s(_vm.selectedItem.name != 'Others' ? _vm.selectedItem.name : (_vm$selectedItem$othe = _vm.selectedItem.other_name) !== null && _vm$selectedItem$othe !== void 0 ? _vm$selectedItem$othe : '-'))]), _c('b-col', {
    staticClass: "mb-3 text-gray",
    attrs: {
      "md": "2"
    }
  }, [_vm._v(" Kind of Task ")]), _c('b-col', {
    attrs: {
      "md": "4"
    }
  }, [_vm._v(_vm._s(_vm.findText(_vm.optionsKindTask, _vm.selectedItem.kind_task_id)))]), _c('b-col', {
    staticClass: "mb-3 text-gray",
    attrs: {
      "md": "2"
    }
  }, [_vm._v(" Work Item")]), _c('b-col', {
    attrs: {
      "md": "4"
    }
  }, [_vm._v(_vm._s((_vm$selectedItem2 = _vm.selectedItem) === null || _vm$selectedItem2 === void 0 ? void 0 : _vm$selectedItem2.title))]), _c('b-col', {
    staticClass: "mb-3 text-gray",
    attrs: {
      "md": "2"
    }
  }, [_vm._v(" Est. Start Date ")]), _c('b-col', {
    attrs: {
      "md": "4"
    }
  }, [_vm._v(" " + _vm._s(_vm.moment(_vm.selectedItem.start_at).format('DD MMM YYYY')) + " ")]), _c('b-col', {
    staticClass: "mb-3 text-gray",
    attrs: {
      "md": "2"
    }
  }, [_vm._v("Type R & M")]), _c('b-col', {
    attrs: {
      "md": "4"
    }
  }, [_vm._v(" " + _vm._s(_vm.findText(_vm.optionsTaskType, _vm.selectedItem.task_type_id)) + " ")]), _c('b-col', {
    staticClass: "mb-3 text-gray",
    attrs: {
      "md": "2"
    }
  }, [_vm._v("Est. Finish Date")]), _c('b-col', {
    attrs: {
      "md": "4"
    }
  }, [_vm._v(_vm._s(_vm.moment(_vm.selectedItem.estimated_finished_at).format('DD MMM YYYY')))]), _c('b-col', {
    staticClass: "mb-3 text-gray",
    attrs: {
      "md": "2"
    }
  }, [_vm._v(" Department ")]), _c('b-col', {
    attrs: {
      "md": "4"
    }
  }, [_vm._v(" " + _vm._s(_vm.findText(_vm.optionsDepartment, _vm.selectedItem.department_id)) + " ")]), _c('b-col', {
    staticClass: "mb-3 text-gray",
    attrs: {
      "md": "2"
    }
  }, [_vm._v("Est. Cost Item Repair ")]), _vm.editable ? _c('b-col', {
    attrs: {
      "md": "4"
    }
  }, [_c('InputCurrency', {
    model: {
      value: _vm.selectedItem.cost_estimate,
      callback: function callback($$v) {
        _vm.$set(_vm.selectedItem, "cost_estimate", $$v);
      },
      expression: "selectedItem.cost_estimate"
    }
  })], 1) : _c('b-col', {
    attrs: {
      "md": "4"
    }
  }, [_vm._v(" " + _vm._s(_vm.formatCurrency(_vm.selectedItem.cost_estimate)) + " ")]), _c('b-col', {
    staticClass: "mb-3 text-gray",
    attrs: {
      "md": "2"
    }
  }, [_vm._v("Repair Section")]), _c('b-col', {
    attrs: {
      "md": "4"
    }
  }, [_vm._v(_vm._s(_vm.selectedItem.section))]), ((_vm$selectedItem$stat = _vm.selectedItem.status) === null || _vm$selectedItem$stat === void 0 ? void 0 : _vm$selectedItem$stat.name) == 'Finish' ? [_c('b-col', {
    staticClass: "mb-3 text-gray",
    attrs: {
      "md": "2"
    }
  }, [_vm._v("Real Cost Item Repair ")]), _c('b-col', {
    attrs: {
      "md": "4"
    }
  }, [_vm._v(" " + _vm._s(_vm.formatCurrency(_vm.selectedItem.cost_real)) + " ")])] : _vm._e(), _c('b-col', {
    staticClass: "mb-3 text-gray",
    attrs: {
      "md": "2"
    }
  }, [_vm._v("Category")]), _c('b-col', {
    attrs: {
      "md": "4"
    }
  }, [_vm._v(" " + _vm._s(_vm.findText(_vm.optionsCategory, _vm.selectedItem.category_id)) + " ")]), _c('b-col', {
    staticClass: "mb-3 text-gray",
    attrs: {
      "md": "2"
    }
  }, [_vm._v("Classification")]), _c('b-col', {
    attrs: {
      "md": "4"
    }
  }, [_vm._v(" " + _vm._s(_vm.findText(_vm.optionsClassification, _vm.selectedItem.classification_id)) + " ")]), _c('b-col', {
    staticClass: "mb-3 text-gray",
    attrs: {
      "md": "2"
    }
  }, [_vm._v("Attachment")]), _c('b-col', {
    attrs: {
      "md": "4"
    }
  }, _vm._l(_vm.selectedItem.filePreview, function (url, idx) {
    var _ref;
    return _c('div', {
      key: "".concat(idx),
      staticClass: "p-0 pr-2 pb-2",
      staticStyle: {
        "max-width": "200px"
      }
    }, [_c('AttachmentSR', {
      attrs: {
        "modelId": _vm.selectedItem.id,
        "modelName": "sr_form_repair",
        "url": (_ref = (url !== null && url !== void 0 && url.id ? _vm.apiUrl : '') + (url === null || url === void 0 ? void 0 : url.path)) !== null && _ref !== void 0 ? _ref : url === null || url === void 0 ? void 0 : url.url,
        "file": url,
        "isPreview": true
      },
      on: {
        "delete": function _delete() {
          return _vm.handleDeleteFile(_vm.selectedItem, idx);
        }
      }
    })], 1);
  }), 0), _c('b-col', {
    staticClass: "mb-3 text-gray",
    attrs: {
      "md": "2"
    }
  }, [_vm._v("Cause")]), _c('b-col', {
    attrs: {
      "md": "4"
    }
  }, [_vm._v(" " + _vm._s(_vm.findText(_vm.optionsCause, _vm.selectedItem.case_id)) + " ")]), _c('b-col', {
    staticClass: "mb-3 text-gray",
    attrs: {
      "md": "2"
    }
  }, [_vm._v("Remarks")]), _c('b-col', {
    attrs: {
      "md": "4"
    }
  }, [_vm._v(" " + _vm._s(_vm.selectedItem.description) + " ")]), _vm.isApprove ? _c('b-col', {
    staticClass: "d-flex justify-content-end",
    attrs: {
      "md": "12"
    }
  }, [_vm.selectedItem.isApprove ? _c('b-button', {
    staticClass: "mr-2",
    attrs: {
      "type": "button",
      "variant": "danger"
    },
    on: {
      "click": function click($event) {
        _vm.selectedItem.isApprove = false;
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-close"
  }), _vm._v(" Reject ")]) : _c('b-button', {
    attrs: {
      "type": "button",
      "variant": "success"
    },
    on: {
      "click": function click($event) {
        _vm.selectedItem.isApprove = true;
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-thumbs-up"
  }), _vm._v(" Approve ")])], 1) : _vm._e()], 2);

}
var staticRenderFns = []

export { render, staticRenderFns }